import exportFromJSON from "../../../utils/csvSafe";
import { NavigateFunction } from "react-router-dom";
import { setErrorMsg } from "../../../redux/reducers/settingsSlice";
import { store } from "./../../../redux/store";
import { getMaunalSalaryData } from "./API";
import { StatusType } from "../types";
import { DateObject } from "react-multi-date-picker";

export interface filters {
  page?: number;
  size?: number;
  searchText?: string;
  loadAllDocuments: boolean;
  status?: string;
}

export interface ManualSalaryObject {
  customerName?: string;
  nationalId?: string;
  financialDataId?: number;
  applicationDate?: string;
  promotionalOffer?: string;
  salaryStage?: StatusType;
  nationality?: string;
  source?: string;
  salaryType?: string
}

export interface ManualSalaryList {
  details: ManualSalaryObject[];
  totalCount: number;
}

export const callRequest = async (
  setData: React.Dispatch<React.SetStateAction<ManualSalaryList>>,
  filters: filters
) => {
  setData(null);
  await getMaunalSalaryData(filters, (_, data) => {
    setData({
      details: data?.details ?? [],
      totalCount: data?.totalCount ?? 0,
    });
  });
};

export const formateDate = (item) => {
  // return item ? new Date(item).toLocaleString() : "-";
  try {
    if (!item) return "-";
    const date = new Date(item);
    const formattedDate = date.toLocaleDateString("en-GB"); // e.g., 14/05/2025
    return formattedDate;
  } catch (error) {
    return "-";
  }
};

export const formateDateWithTime = (item) => {
  if (!item) return "-";

  try {
    // ISO UTC string → converted to LOCAL timezone automatically
    const date = new Date(item);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours(); // LOCAL hours
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return (
      <>
        {day}-{month}-{year} {String(hours).padStart(2, "0")}:{minutes} {ampm}
      </>
    );
  } catch {
    return "-";
  }
};

// Printing pagination items
export const paginationElemnts = (
  dataArray: ManualSalaryObject[],
  currentPage: number,
  length: number,
  setFilters: (value: React.SetStateAction<filters>) => void
): JSX.Element[] => {
  let pages: JSX.Element[] = [];
  let totalPage = Math.ceil(length / 10);

  const first = (
    <li key={1} className={"page-item" + (1 === currentPage ? " active" : "")}>
      <button
        className="btn btn-link"
        onClick={(e) => setFilters((res) => ({ ...res, page: 1 }))}
      >
        1
      </button>
    </li>
  );
  const last = (
    <li
      key={totalPage}
      className={"page-item" + (totalPage === currentPage ? " active" : "")}
    >
      <button
        className="btn btn-link"
        onClick={(e) => setFilters((res) => ({ ...res, page: totalPage }))}
      >
        {totalPage}
      </button>
    </li>
  );

  if (currentPage - 1 > 1) pages.push(first);
  for (let i = currentPage - 1; i <= currentPage + 1; i++) {
    if (i > 0 && i <= totalPage) {
      const element = (
        <li
          key={i.toString()}
          className={"page-item" + (i === currentPage ? " active" : "")}
        >
          <button
            className="btn btn-link"
            onClick={(e) => setFilters((res) => ({ ...res, page: i }))}
          >
            {i}
          </button>
        </li>
      );
      pages.push(element);
    }
    if (i === currentPage && dataArray?.length < 10) break;
  }
  if (totalPage - currentPage > 1) pages.push(last);

  return pages;
};

// Open details popup
export const showDetails = (
  t,
  Relatedparties: ManualSalaryObject,
  navigate: NavigateFunction
) => {
  store.dispatch(
    setErrorMsg({
      icon: null,
      title: t("More Details"),
      message: (
        <div className="scroller-area" style={{ maxHeight: 550, padding: 20 }}>
          <div className="row">
            {printElements(t, Relatedparties).map((item) => item)}
          </div>
        </div>
      ),
    })
  );
};

const printElements = (t, dataArray: any): JSX.Element[] => {
  const array: JSX.Element[] = [];
  Object.keys(dataArray).forEach((key) => {
    array.push(
      <div className="col-12 col-md-6" key={key}>
        <div className="bordered-box">
          <strong>{t("inputs.payouts." + key).toString()}</strong>
          <span className="ms-2">
            {dataArray[key] === "" ||
            dataArray[key] === false ||
            dataArray[key] === undefined
              ? "-"
              : dataArray[key].toString()}
          </span>
        </div>
      </div>
    );
  });
  return array;
};

export const exportData = async (
  filters: filters,
  t: (key: string) => string
) => {
  await getMaunalSalaryData(
    { ...filters, loadAllDocuments: true },
    (success, data) => {
      if (success && data && data?.details && data?.details?.length) {
        const fields = {
          createdAt: t("manualSalary.applicationDate"),
          nationalId: t("manualSalary.idNumber"),
          nationality: t("manualSalary.nationality"),
          source: t("manualSalary.source"),
          customerName: t("manualSalary.customerName"),
          financialDataId: t("manualSalary.applicationId"),
          applicationStatus: t("manualSalary.applicationStatus"),
          offer: t("manualSalary.offer"),
        };
        const newData = [];
        data?.details?.forEach((item: ManualSalaryObject) => {
          // use forEach instead of map
          newData.push({
            createdAt: item.applicationDate ?? "",
            nationalId: item.nationalId ?? "",
            nationality: item.nationality ?? "",
            source: item.source ?? "",
            customerName: item.customerName ?? "",
            financialDataId: item.financialDataId ?? "",
            applicationStatus: item.salaryStage ?? "",
            offer: item.promotionalOffer ?? "",
          });
        });

        const fileName = "Manual_Salary";
        const exportType = exportFromJSON.types.csv;
        exportFromJSON({
          data: newData,
          fileName,
          exportType,
          fields,
          withBOM: true,
        });
      } else {
        // Optionally handle error or notify user
        // message("Export failed or no data to export.", false);
      }
    }
  );
};

export const safeDateObject = (value?: string | null): DateObject | null => {
  if (!value) return null;

  try {
    const date = new DateObject(value);

    // Optional: validate parsed date
    if (!date.isValid) return null;

    return date;
  } catch {
    return null;
  }
};

export const isoToLocalYYYYMMDD = (iso: string): string => {
  if (!iso) return "-";

  try {
    // JS Date supports milliseconds only
    const safeIso = iso.replace(/(\.\d{3})\d+Z$/, "$1Z");

    const date = new Date(safeIso);
    if (isNaN(date.getTime())) return "-";

    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  } catch {
    return "-";
  }
};

